module.exports = __webpack_public_path__ + "img/1.09fc3c2d.gif";